import { render, staticRenderFns } from "./RinvN.vue?vue&type=template&id=2679bfe6"
import script from "./RinvN.vue?vue&type=script&lang=js"
export * from "./RinvN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports